import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import Layout from './components/layout/Layout';
// import { AdminLogin } from './pages/AdminLogin';
// import reportWebVitals from './reportWebVitals';
// import { SnackbarProvider } from "notistack";
import { AdminAuthProvider } from "./context/AdminAuthContext";



const root = ReactDOM.createRoot(document.getElementById('root'));
//  const router =  createBrowserRouter(
//     createRoutesFromElements(
//       <Route path='/' element={<Layout />}>
//           <Route element={<AdminLogin/>} path="admin1" />
//       </Route>
//     )
//   )

root.render(

 <>
  
  {/* <RouterProvider router={router} />    */}
  <BrowserRouter>
  <React.StrictMode> 
    <App/>
  </React.StrictMode>
  </BrowserRouter>
  </>
);


